import { render, staticRenderFns } from "./DescView.vue?vue&type=template&id=baebc9c4&scoped=true"
import script from "./DescView.vue?vue&type=script&lang=js"
export * from "./DescView.vue?vue&type=script&lang=js"
import style0 from "./DescView.vue?vue&type=style&index=0&id=baebc9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baebc9c4",
  null
  
)

export default component.exports